export default "__VITE_ASSET__xxPwdfB2__"